import { useMsal } from '@azure/msal-react';
import { useOnMount } from '@/hooks/useOnMount';

export default function Logout() {
    const { instance } = useMsal();

    useOnMount(() => instance.logoutRedirect());

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
            }}
        >
            <h4>Logging out...</h4>
        </div>
    );
}
